import { useTranslation } from 'react-i18next';

import { Button } from '@/components/common/Button';
import { useHaptics } from '@/hooks/useHaptics';
import {
  FILTRI_LIVE,
  alternaFiltro,
  eUltimoAcceso,
  type FiltroLive,
} from '@/lib/limulo/filtriLive';

/**
 * I tre filtri della Live (r11): tornei, sit&go, code. Scelta MULTIPLA: sono `Button variant="scelta"`
 * (`aria-pressed`), non `Segmented`/`UnderlineTabs`, che sono schede (`role="tab"`, una sola attiva).
 * Le regole — tutti accesi all'apertura, l'ultimo non si spegne — sono di `lib/limulo/filtriLive.ts`; qui
 * c'e' solo il disegno. L'ultimo acceso e' `disabled`: cosi' si vede perche' non risponde.
 * Le etichette sono i titoli delle sezioni (`live.family.*`): la stessa parola, due posti.
 */
const ETICHETTA: Readonly<Record<FiltroLive, { key: string; defaultValue: string }>> = {
  torneo: { key: 'live.family.tournament', defaultValue: 'Tournaments' },
  'sit-and-go': { key: 'live.family.sitAndGo', defaultValue: 'Sit&Go' },
  coda: { key: 'live.family.coda', defaultValue: 'Queues' },
};

export function FiltriLive({
  accesi,
  onChange,
}: {
  accesi: ReadonlySet<FiltroLive>;
  onChange: (prossimi: ReadonlySet<FiltroLive>) => void;
}) {
  const { t } = useTranslation('hub');
  const haptics = useHaptics();
  return (
    <div
      role="group"
      aria-label={t('live.filters', { defaultValue: 'Filter matches' })}
      data-testid="cr-live-filtri"
      className="flex flex-wrap gap-2 px-1"
    >
      {FILTRI_LIVE.map((f) => (
        <Button
          key={f}
          variant="scelta"
          pressed={accesi.has(f)}
          disabled={eUltimoAcceso(accesi, f)}
          data-testid={`cr-live-filtro-${f}`}
          onClick={() => {
            haptics.selection();
            onChange(alternaFiltro(accesi, f));
          }}
        >
          {t(ETICHETTA[f].key, { defaultValue: ETICHETTA[f].defaultValue })}
        </Button>
      ))}
    </div>
  );
}
